import React from 'react';
import { type IconProps, type IIconProps } from '../dm/icons.js';
import {
  Bug,
  ChatDots,
  ChatLeftQuote,
  ExclamationTriangle,
  LifePreserver,
  Megaphone,
  Mortarboard,
  Stars,
  Translate,
} from 'react-bootstrap-icons';

const AnnouncementsIcon = ({ size, color, ...props }: IIconProps) => {
  return <Megaphone height={size} width={size} fill={color} {...props} />;
};

const KbIcon = ({ size, color, ...props }: IIconProps) => {
  return <Mortarboard height={size} width={size} fill={color} {...props} />;
};

const QnaIcon = ({ size, color, ...props }: IIconProps) => {
  return <ChatDots height={size} width={size} fill={color} {...props} />;
};

const BugIcon = ({ size, color, ...props }: IIconProps) => {
  return <Bug height={size} width={size} fill={color} {...props} />;
};

const GeneralIcon = ({ size, color, ...props }: IIconProps) => {
  return <LifePreserver height={size} width={size} fill={color} {...props} />;
};

const FeedbackIcon = ({ size, color, ...props }: IIconProps) => {
  return <ChatLeftQuote height={size} width={size} fill={color} {...props} />;
};

const AlertsIcon = ({ size, color, ...props }: IIconProps) => {
  return <ExclamationTriangle height={size} width={size} fill={color} {...props} />;
};

const TranslateIcon = ({ size, color, ...props }: IIconProps) => {
  return <Translate height={size} width={size} fill={color} {...props} />;
};

const EnhancementIcon = ({ size, color, ...props }: IIconProps) => {
  return <Stars height={size} width={size} fill={color} {...props} />;
};

export const commsIcons = [
  'announcements',
  'kb',
  'qna',
  'bugs',
  'general',
  'feedback',
  'alerts',
  'translate',
  'enhancement',
];
export type EditorIconType = (typeof commsIcons)[number];

interface ICommsIcons extends IconProps {
  type: EditorIconType;
}
export const CommsIcons = ({ size = '1em', color = 'currentColor', type, className }: ICommsIcons) => {
  const props: IIconProps = { size, color, className };

  switch (type) {
    case 'announcements': {
      return <AnnouncementsIcon {...props} />;
    }
    case 'bugs': {
      return <BugIcon {...props} />;
    }
    case 'kb': {
      return <KbIcon {...props} />;
    }
    case 'qna': {
      return <QnaIcon {...props} />;
    }
    case 'general': {
      return <GeneralIcon {...props} />;
    }
    case 'feedback': {
      return <FeedbackIcon {...props} />;
    }
    case 'alerts': {
      return <AlertsIcon {...props} />;
    }
    case 'translate': {
      return <TranslateIcon {...props} />;
    }
    case 'enhancement': {
      return <EnhancementIcon {...props} />;
    }
  }
};
